import project1 from '../images/project1.JPG';
import project2 from '../images/project2.JPG';
import project3 from '../images/project3.JPG';
import project4 from '../images/project4.JPG';
import project5 from '../images/project5.JPG';
import project6 from '../images/project6.JPG';
import project7 from '../images/project7.JPG';
import project8 from '../images/project8.JPG';
import project9 from '../images/project9.JPG';

const AllProjects = [
    {
        id: 1,
        category: 'Full Stack',
        link1: 'https://laptop-bazar-6ddea.web.app/',
        link2: 'https://github.com/mehadiHasanDiner/client-side-laptop-bazar',
        icon1: 'Live',
        icon2: 'Git',
        image: project1,
        title: 'Full Stack'
    },
    {
        id: 2,
        category: 'Full Stack',
        link1: 'https://cooking-school-client.web.app/',
        link2: 'https://github.com/mehadiHasanDiner/client-side-cooking-school',
        icon1: 'Live',
        icon2: 'Git',
        image: project2,
        title: 'Full Stack'
    },
    {
        id: 4,
        category: 'React JS',
        link1: 'https://angry-blackwell-fb1053.netlify.app/',
        link2: 'https://github.com/mehadiHasanDiner/react-router-assignment-8',
        icon1: 'Live',
        icon2: 'Git',
        image: project4,
        title: 'React Routing'
    },
    {
        id: 7,
        category: 'Use API',
        link1: 'https://mehadihasandiner.github.io/assignment-5_Hungry-Monster/index.html',
        link2: 'https://github.com/mehadiHasanDiner/assignment-5_Hungry-Monster',
        icon1: 'Live',
        icon2: 'Git',
        image: project7,
        title: 'Use API'
    },
    {
        id: 8,
        category: 'Vanilla JavaScript',
        link1: 'https://mehadihasandiner.github.io/milestone-4_assignment-4/',
        link2: 'https://github.com/mehadiHasanDiner/milestone-4_assignment-4',
        icon1: 'Live',
        icon2: 'Git',
        image: project8,
        title: 'Vanilla JavaScript Website'
    },
    {
        id: 3,
        category: 'Debugging',
        link1: 'https://mehadihasandiner.github.io/milestone-6_Assignment-6/index.html',
        link2: 'https://github.com/mehadiHasanDiner/milestone-6_Assignment-6',
        icon1: 'Live',
        icon2: 'Git',
        image: project3,
        title: 'Website debugging'
    },
    
    {
        id: 5,
        category: 'React JS',
        link1: 'https://optimistic-nightingale-a5ac78.netlify.app/',
        link2: 'https://github.com/mehadiHasanDiner/react-auth-milstone-9',
        icon1: 'Live',
        icon2: 'Git',
        image: project5,
        title: 'React and Firebase'
    },
    {
        id: 6,
        category: 'React JS',
        link1: 'https://optimistic-nobel-4e9e99.netlify.app/',
        link2: 'https://github.com/mehadiHasanDiner/react-premier-league-assignment-7',
        icon1: 'Live',
        icon2: 'Git',
        image: project6,
        title: 'React using Fake data'
    },

    
    {
        id: 9,
        category: 'Vanilla JavaScript',
        link1: 'https://mehadihasandiner.github.io/toDoList/',
        link2: 'https://github.com/mehadiHasanDiner/toDoList',
        icon1: 'Live',
        icon2: 'Git',
        image: project9,
        title: 'Vanilla JavaScript Website'
    },
]

export default AllProjects;